<div [ngClass]="{ 'card__head--sticker': sticker }" class="card__head">
    <span *ngIf="index" class="card__index">
        <span class="card__index-value">{{ index }}</span>
    </span>
    <ng-content></ng-content>
</div>
